import axios from "../axios";

export const list = (data) => {
  return axios({
    url: '/hyzq/list',
    method: 'post',
    headers: {'Content-Type': 'application/json'},
    noSerializeData: true,//不序列化参数
    data
  })
}

export const findById = (data) => {
  return axios({
    url: '/hyzq/findById',
    method: 'post',
    data
  })

}
/**
 * 删除
 * @param data
 * @returns {Promise | Promise<unknown>}
 */
export const remove = (data) => {
  return axios({
    url: '/hyzq/delete',
    method: 'post',
    data
  })
}

export const save = (data) => {
  return axios({
    url: '/hyzq/save',
    method: 'post',
    headers: {'Content-Type': 'application/json'},
    noSerializeData: true,//不序列化参数
    data
  })
}



// WEBPACK FOOTER //
// ./src/http/moudules/hyzq.js